import axios from 'axios';

const instance = axios.create({
  baseURL: window.Portal ? window.Portal.baseUrl : '',
  headers: {
    'X-CSRF-TOKEN': window.Portal ? window.Portal.csrfToken : '',
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json'
  },
  validateStatus: function (status) {
    return status >= 200 && status < 300;
  }
});

instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default instance;
